/**
 * Real-time password validation feedback.
 *
 * Attaches to any password + confirm pair and shows a checklist
 * of requirements that update as the user types.
 *
 * Usage: add data-password-validate="true" to the password input.
 *        The confirm input is found by id="confirm-password" or
 *        name="password_confirmation".
 */
(function () {
    var passwordInput = document.getElementById('password');
    if (!passwordInput || !passwordInput.getAttribute('data-password-validate')) return;

    // Find the confirm input
    var confirmInput = document.getElementById('confirm-password')
        || document.querySelector('input[name="password_confirmation"]');

    // Detect auth layout (dark background, white text)
    var isAuthLayout = !!document.querySelector('.hfs-auth-logo');
    var mutedClass = isAuthLayout ? 'text-white-50' : 'text-muted';

    // Build the checklist UI
    var container = document.createElement('div');
    container.className = 'password-requirements mt-2';
    container.innerHTML =
        '<small class="' + mutedClass + ' d-block mb-1">Password requirements:</small>' +
        '<ul class="list-unstyled mb-0 small">' +
        '<li id="pw-req-length"><i class="fa fa-circle pw-req-icon"></i> At least 8 characters</li>' +
        '<li id="pw-req-upper"><i class="fa fa-circle pw-req-icon"></i> At least one uppercase letter</li>' +
        '<li id="pw-req-lower"><i class="fa fa-circle pw-req-icon"></i> At least one lowercase letter</li>' +
        '<li id="pw-req-number"><i class="fa fa-circle pw-req-icon"></i> At least one number</li>' +
        '</ul>';

    // Insert after the password input's closest wrapper
    var parentGroup = passwordInput.closest('.form-group') || passwordInput.closest('.mb-3') || passwordInput.parentElement;
    if (parentGroup) {
        parentGroup.appendChild(container);
    }

    // Match indicator (added after confirm input's wrapper)
    var matchIndicator = null;
    if (confirmInput) {
        matchIndicator = document.createElement('div');
        matchIndicator.className = 'mt-1 small';
        matchIndicator.id = 'pw-req-match';
        matchIndicator.innerHTML = '<i class="fa fa-circle pw-req-icon"></i> Passwords match';
        matchIndicator.style.display = 'none';

        var confirmGroup = confirmInput.closest('.form-group') || confirmInput.closest('.mb-3') || confirmInput.parentElement;
        if (confirmGroup) {
            confirmGroup.appendChild(matchIndicator);
        }
    }

    // Add styles
    var style = document.createElement('style');
    style.textContent =
        '.pw-req-icon { font-size: 8px; margin-right: 6px; vertical-align: middle; }' +
        '.pw-req-fail { color: #dc3545; }' +
        '.pw-req-pass { color: #198754; }' +
        '.pw-req-pass .pw-req-icon:before { content: "\\f00c" !important; font-size: 12px; }' +
        '.pw-req-pass .fa { font-family: "Font Awesome 6 Free"; font-weight: 900; }';
    document.head.appendChild(style);

    function validate() {
        var val = passwordInput.value;
        var hasValue = val.length > 0;

        // Only show requirements once user starts typing
        container.style.display = hasValue ? 'block' : 'none';

        check('pw-req-length', val.length >= 8);
        check('pw-req-upper', /[A-Z]/.test(val));
        check('pw-req-lower', /[a-z]/.test(val));
        check('pw-req-number', /[0-9]/.test(val));

        if (matchIndicator && confirmInput) {
            var confirmVal = confirmInput.value;
            var showMatch = hasValue && confirmVal.length > 0;
            matchIndicator.style.display = showMatch ? 'block' : 'none';
            if (showMatch) {
                check('pw-req-match', val === confirmVal);
            }
        }
    }

    function check(id, passed) {
        var el = document.getElementById(id);
        if (el) {
            el.className = passed ? 'pw-req-pass' : 'pw-req-fail';
        }
    }

    passwordInput.addEventListener('input', validate);
    if (confirmInput) {
        confirmInput.addEventListener('input', validate);
    }

    // Initial state — hidden until user types
    container.style.display = 'none';
})();
